module.exports = __webpack_public_path__ + "static/media/Logo.187d50ac.png";